export default {
  RapidRewardsNumber__ACCOUNT_NUMBER: (option) => `Account# ${option.accountNumber}`,
  RapidRewardsNumber__ACCOUNT_NUMBER__SCREEN_READER: (option) =>
    `Account number ${option.accountNumber}`,
  RapidRewardsNumber__RR_NUMBER: (option) => `RR# ${option.accountNumber}`,
  RapidRewardsNumber__RR_NUMBER__SCREEN_READER: (option) =>
    `Rapid Rewards number ${option.accountNumber}`,
};
